import { usePanel, usePermissions } from "@motolynk/app-core";

import type { MediaPanel } from "./api";

/** What the user may do here. Admin: Django permissions. Vendor: their own library (checked by the server). */
export function useMediaAccess() {
  const { panel } = usePanel();
  const { can } = usePermissions();
  const vendor = panel === "vendor";
  return {
    panel: (vendor ? "vendor" : "admin") as MediaPanel,
    // vendor panel: every store role with `media.manage` manages the store's own library (ADR 0029)
    canUpload: vendor ? can("media.manage") : can("medialib.add_mediafile"),
    canEdit: vendor ? can("media.manage") : can("medialib.change_mediafile"),
    canDelete: vendor ? can("media.manage") : can("medialib.delete_mediafile"),
    /** Only admins may delete files that are still in use (and see every owner). */
    isAdmin: !vendor,
  };
}
